const statusFilterConstantsEn = {
  statusPlaceholder: 'Status',
  allFilter: 'All',
  newFilter: 'New',
  pendingFilter: 'Pending',
  rejectedFilter: 'Rejected',
  approvedFilter: 'Approved',
};
export default statusFilterConstantsEn;
